import React from 'react';
import { Checkbox } from './ui/checkbox';
import { Badge } from './ui/badge';
import { ArrowRight } from 'lucide-react';

export function FieldRow({ field, label, current, extracted, kind, checked, onCheck, testId }) {
  const isNew = kind === 'new';
  const bgClass = isNew ? '' : ' bg-amber-50/30 dark:bg-amber-950/10';
  const arrowClass = isNew ? 'text-green-500' : 'text-amber-500';
  const valClass = isNew ? 'text-green-700 dark:text-green-400' : 'text-amber-700 dark:text-amber-400';
  const badgeClass = isNew ? 'bg-green-500/15 text-green-600 border-green-500/20' : 'bg-amber-500/15 text-amber-600 border-amber-500/20';

  return (
    <div className={'flex items-center gap-3 px-4 py-2 hover:bg-muted/20' + bgClass} data-testid={testId}>
      <Checkbox checked={checked} onCheckedChange={onCheck} />
      <span className="font-body text-xs font-medium text-muted-foreground w-28 shrink-0 truncate">{label}</span>
      <span className={'font-body text-xs flex-1 truncate ' + (isNew ? 'text-muted-foreground/50 italic' : 'text-foreground')}>
        {isNew ? '—' : current}
      </span>
      <ArrowRight className={'w-3 h-3 shrink-0 ' + arrowClass} />
      <span className={'font-body text-xs flex-1 font-medium truncate ' + valClass}>{extracted}</span>
      <Badge className={'text-[9px] shrink-0 hover:bg-transparent ' + badgeClass}>
        {isNew ? 'New' : 'Changed'}
      </Badge>
    </div>
  );
}

export function ListRow({ field, label, count, checked, onCheck }) {
  return (
    <div className="flex items-center gap-3 px-4 py-2.5 border-t border-border/50" data-testid={'list-' + field}>
      <Checkbox checked={checked} onCheckedChange={onCheck} />
      <span className="font-body text-sm flex-1">{label}</span>
      <Badge variant="secondary" className="text-[10px]">{count} items</Badge>
    </div>
  );
}
